<template>
  <div
    id="$address-book$"
    class="address-book fb-col-start-start"
    :class="{ 'pb-48': computedNodes.length > 0 }"
    :style="computedSizeStyle"
  >
    <template v-if="isShowSelectDetail">
      <div class="select-wrap item-flex-1 scroll-y font-34 pb-60">
        <template v-for="(node, index) in selectedList">
          <div
            class="h-56 p-0-16 bg-FFFFFF"
            :key="`${node.dormNodeType}${node.dormNodeId}`"
          >
            <div
              class="fb fb-cross-center"
              :class="{
                bb:
                  index < selectedList.length - 1 &&
                  !isShowDormTitle(node, index)
              }"
              style="height: 100%"
            >
              <div class="item-flex-1">
                <div class="fb fb-col fb-main-center">
                  <div class="fb fb-main-start fb-cross-center">
                    <div class="font-34 pr-5 text-ellipsis">
                      {{ formatDormName(node) }}
                      <span v-show="node.selectedCount" class="ml-8 c-006AFE">
                        ({{ node.selectedCount }})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <span class="delete" @click.stop="handleDelete(index, node)">
                <i class="iconfont c-171A1D-40">&#xe670;</i>
              </span>
            </div>
          </div>
          <div
            v-if="isShowDormTitle(node, index)"
            class="font-36 dorm-title c-191F25-40"
            :key="`${node.dormNodeId}` + index"
          >
            宿舍
          </div>
        </template>
      </div>
      <div class="footer font-26 fb fb-main-center fb-cross-center">
        <common-button @click="ensureClearAction" type="add" class="mr-16">
          清空
        </common-button>
        <common-button type="primary" @click="confirmDetail">
          确定
        </common-button>
      </div>
    </template>
    <template v-else>
      <!-- 部门层级导航 -->
      <common-node-nav
        :nodeNav="computedNodeNav"
        ref="nodeNav"
        @click="handlerToGoBackTargetNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-if="compuedIsShowSelectAll"
        class="select-all fb-start-center font-34"
        :class="{
          'disabled-choose': compuedIsDisableSelectAll
        }"
        @click="handlerToChangeSelectAllStatus"
      >
        <span class="mr-8 mt-2">
          <i v-show="!compuedIsSelectedAll" class="iconfont c-171A1D-40 font-44"
            >&#xe66f;</i
          >
          <i v-show="compuedIsSelectedAll" class="iconfont c-006AFE font-44"
            >&#xe66e;</i
          >
        </span>
        <span class="item-flex-1">全选</span>
      </div>
      <div
        v-show="!computedNodes.length && reqStatus"
        class="h-full c-171A1D-56 fb-col-center-center item-flex-1 icon-no-data-box"
      >
        <div class="icon-no-data"></div>
        <span class="font-34">暂无数据</span>
      </div>
      <!-- 子级部门列表-->
      <div v-if="computedNodes.length > 0" class="node-list font-34">
        <div
          v-for="(node, idx) in computedNodes"
          class="fb-start-center h-56"
          :key="node.tpId"
          @click="handlerToChangeSelectedStatus(node)"
        >
          <span
            v-if="isShowSelectBox(node)"
            class="mr-12 mt-2"
            :class="{
              'disabled-choose': isDisabled(node)
            }"
          >
            <i v-show="!node.selected" class="iconfont c-171A1D-40 font-48">
              &#xe66f;
            </i>
            <i v-show="node.selected" class="iconfont c-006AFE font-48">
              &#xe66e;
            </i>
          </span>
          <div
            class="item-flex-1 fb fb-cross-center hidden"
            :class="{ bb: idx < computedNodes.length - 1 }"
            style="height: 100%"
          >
            <div
              class="item-flex-1 hidden"
              :class="{
                'disabled-choose': isDisabled(node)
              }"
            >
              <div class="fb fb-col fb-main-center">
                <div class="fb fb-main-start fb-cross-center">
                  <div class="font-34 pr-5 fb fb-cross-center hidden">
                    <div class="node-name item-flex-1 text-ellipsis">{{
                      formatDormName(node)
                    }}</div>

                    <div
                      v-show="node.dormNum"
                      :class="[
                        'ml-8',
                        node.dormNum
                          ? node.selectedCount
                            ? 'c-006AFE'
                            : 'c-171A1D-40'
                          : 'c-171A1D-28'
                      ]"
                    >
                      ({{ node.selectedCount || 0 }}/{{ node.dormNum }})
                    </div>
                  </div>
                </div>
                <div class="fb fb-row fb-cross-center fb-main-start"> </div>
              </div>
            </div>
            <span
              v-if="isCanOpen(node)"
              class="next"
              @click.stop="handlerToGetSubNodes(node)"
            >
              <i class="iconfont">&#xe714;</i>下级
            </span>
          </div>
        </div>
      </div>
      <div class="result font-26 fb-start-center">
        <div class="item-flex-1 c-006AFE" @click.stop="handlerViewDetail">
          已选择: {{ computedResulCount }}个宿舍
          <i v-show="computedResulCount" class="ml-8 c-006AFE iconfont font-38"
            >&#xe610;</i
          >
        </div>
        <div>
          <common-button width="95" height="32" @click="handlerToSubmit"
            >确定</common-button
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { commonNodeNav, commonButton } from '@/components/commonAddressBook'
import { LEAVE_ROLE } from '@/utils/constUtils'
import { setLeft, removeLeft, pushNullUrl } from '@/utils/comUtils'
import API from '@/api'
import { mcConfirm, mcSetTitle } from '@/utils/mcSdkUtils'

// 校区不展示勾选框；楼、层、宿舍都展示
// 楼 仅支持单选；层、宿舍 支持多选

const NODE_TYPE = {
  campus: -1, // 校区
  building: 1, // 楼
  storey: 2, // 层
  dorm: 3 // 宿舍
}

export default {
  name: 'MSchoolAddressDormList',
  components: {
    commonNodeNav,
    commonButton
  },
  props: {},
  data() {
    return {
      LEAVE_ROLE,
      NODE_TYPE,
      reqStatus: false, // 请求是否已发送完成
      isShowSelectDetail: false, // 回显选择页面
      selectedList: [], // 回显的列表
      nodeNav: [], // 部门导航条
      depts: [], // 校区列表
      currentType: 1, // 当前层级
      defaultSelected: {},
      allClassDetail: [],
      currentCampus: {},
      showConfirm: false,
      campusList: [], // 校区列表
      clearConfirm: null,
      clearNodeList: []
    }
  },
  computed: {
    /**
     * 计算组件尺寸大小
     */
    computedSizeStyle() {
      return {
        width: `${window.innerWidth}px`,
        height: `${window.innerHeight}px`
      }
    },
    // 判断是否显示全选选项
    compuedIsShowSelectAll() {
      // 当前为楼时，楼下面展示的层可多选 当前为层时，宿舍类似
      return (
        this.computedNodes.length &&
        [NODE_TYPE.building, NODE_TYPE.storey].includes(this.currentType)
      )
    },
    // 判断是否禁用全选选项
    compuedIsDisableSelectAll() {
      let _nodeLen = this.computedNodes.length
      return (
        _nodeLen &&
        this.computedNodes.filter(item => !!item.disabled).length === _nodeLen
      )
    },
    // 判断当前节点列表是否已全选
    compuedIsSelectedAll() {
      let _nodeList = this.computedNodes.filter(item => !item.selected)
      return !_nodeList.length
    },
    computedNodeNav() {
      return this.nodeNav.map(node => {
        let { dormNodeType } = node
        return {
          deptId: dormNodeType,
          name: this.formatDormName(node)
        }
      })
    },
    nodeNavLen() {
      return this.nodeNav.length
    },
    // 当前展示部门
    computedNodes() {
      let _navLen = this.nodeNav.length

      if (_navLen <= 1) return this.campusList

      let _lastNode = this.nodeNav[_navLen - 1]
      return _lastNode.nodes || []
    },
    computedResulCount() {
      return this.getSelectedDormCount(this.getSelectedDormList())
    },
    computeDormBuildingId() {
      return (this.depts.filter(node => !!node.selectedCount)[0] || {})
        .dormNodeId
    }
  },
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  mounted() {
    this.title && mcSetTitle(this.title)
    this.init()
  },
  watch: {
    isShowSelectDetail(val) {
      if (!val) {
        this.$nextTick(() => (this.clearNodeList = []))
      }
    }
  },
  beforeDestroy() {
    removeLeft(this.methodSetLeft)
  },
  methods: {
    formatDormName(node) {
      return node.name || node.dormNodeName
    },
    isShowDormTitle(node, index) {
      return (
        node.selectedCount &&
        this.selectedList[index + 1] &&
        !this.selectedList[index + 1].selectedCount
      )
    },
    init() {
      this.nodeNav = []
      this.methodUpdateNodeNav({
        tpId: this.corpId,
        name: this.corpName,
        deptId: 0
      })
      this.getCapmusList()
    },
    isSameNode(node, item) {
      return (
        item.dormNodeType === node.dormNodeType &&
        item.dormNodeId === node.dormNodeId
      )
    },
    // 回显，判断该节点是否被选中
    walkTreeIsSelected(nodeList) {
      if (!(nodeList && nodeList.length)) return

      nodeList.forEach(node => {
        //  selectedMap.selectedList 一定有值
        if (
          node &&
          this.selectedMap.selectedList.find(item =>
            this.isSameNode(node, item)
          )
        ) {
          this.$set(node, 'selected', true)
        }
        this.walkTreeIsSelected(node.nodes)
      })
    },
    // 回显，根据父元素的选中状态，同步子节点的状态
    walkTreeEchoSelected(nodeList, parentNode) {
      if (!(nodeList && nodeList.length)) return

      nodeList.forEach(node => {
        // 如果父节点不存在或者不展示选中框，当前子节点以自身当前状态为准，不做修改。否则同步为父节点的状态。
        if (parentNode && parentNode.selected) {
          this.$set(node, 'selected', true)
        }
        this.walkTreeEchoSelected(node.nodes, node)
      })
    },
    // 根据父元素的状态，同步子节点的状态
    walkTreeSelectedStatus(nodeList, parentNode, clearCount) {
      if (!(nodeList && nodeList.length)) return

      nodeList.forEach(node => {
        clearCount && (node.selectedCount = 0)
        // 如果父节点不存在或者不展示选中框，当前子节点以自身当前状态为准，不做修改。否则同步为父节点的状态。
        if (parentNode && this.isShowSelectBox(parentNode)) {
          this.$set(node, 'selected', !!(parentNode && parentNode.selected))
        }
        this.walkTreeSelectedStatus(node.nodes, node)
      })
    },
    // 根据子节点的状态，计算出父元素选中的数字
    walkTreeSelectedCount() {
      // 从内部计算数字 每次减少一层
      let _nodeTypeStack = [
        NODE_TYPE.building,
        NODE_TYPE.storey,
        NODE_TYPE.dorm
      ]
      while (_nodeTypeStack.length) {
        let _curNodeType = _nodeTypeStack.pop()
        this.walkTreeNodeType({
          nodeList: this.depts,
          nodeType: _curNodeType
        })
      }
    },
    // 根据当前需要处理的最后层级，进行计算
    walkTreeNodeType({ nodeList, parentNode, nodeType }) {
      nodeList.forEach(item => {
        if (item.nodes && item.dormNodeType <= nodeType) {
          this.walkTreeNodeType({
            nodeList: item.nodes,
            parentNode: item,
            nodeType
          })
        } else if (parentNode) {
          // NODE_TYPE.dorm 节点判断的是选中状态
          // 其他节点是 selectedCount 的数字
          let _count = 0
          if (item.dormNodeType === NODE_TYPE.dorm) {
            _count = nodeList.filter(node => node.selected).length
          } else {
            _count = nodeList.reduce((total, currentValue) => {
              return total + (currentValue.selectedCount || 0)
            }, _count)
          }
          this.$set(parentNode, 'selectedCount', _count)

          // hack 如果子节点已选中全部，将父节点置为选中
          this.$set(
            parentNode,
            'selected',
            !!(_count && _count === parentNode.dormNum)
          )
        }
      })
    },
    // 同步状态与重新计算选中的值
    walkTree(nodeList, parentNode) {
      this.walkTreeSelectedStatus(nodeList, parentNode)

      // 一定要整颗树都重新计算
      this.walkTreeSelectedCount()
    },
    // 计算当前节点是否显示勾选框
    isShowSelectBox(node) {
      return [NODE_TYPE.building, NODE_TYPE.storey, NODE_TYPE.dorm].includes(
        node.dormNodeType
      )
    },
    // 计算当前节点是否禁用
    isDisabled(node) {
      return !!node.disabled
    },
    // 计算当前节点是否可展开
    isCanOpen(node) {
      return [NODE_TYPE.campus, NODE_TYPE.building, NODE_TYPE.storey].includes(
        node.dormNodeType
      )
    },
    /**
     * 返回目标节点
     */
    handlerToGoBackTargetNode(_node, index) {
      this.methodUpdateNodeNav(undefined, index)
    },
    // 获取当前展示的列表的对象
    getLastNodeMap() {
      return this.nodeNav[this.nodeNavLen - 1] || {}
    },
    /**
     * 切换节点全选状态
     */
    handlerToChangeSelectAllStatus() {
      if (this.compuedIsDisableSelectAll) return
      let _lastNode = this.getLastNodeMap()
      this.$set(_lastNode, 'selected', !this.compuedIsSelectedAll)
      this.walkTree(_lastNode.nodes, _lastNode)
    },
    /**
     * 切换节点勾选状态
     */
    async handlerToChangeSelectedStatus(node) {
      // 不展示勾选框 或者 被禁用
      if (!this.isShowSelectBox(node) || this.isDisabled(node)) return
      if (node.dormNodeType !== 1) {
        // 清除掉其他所以选中的宿舍楼
        const nodes = this.nodeNav[1].nodes
        nodes.forEach(item => {
          if (item.dormBuildingId !== node.dormBuildingId) {
            item.selected = false
            this.walkTree(item.nodes, item)
          }
        })
      }

      let _selected = !node.selected
      this.$set(node, 'selected', _selected)

      // 不是全选。当前选中，清空兄弟节点状态
      if (!this.compuedIsShowSelectAll && _selected) {
        // 所有当前节点且一定有值
        let { nodes } = this.getLastNodeMap()
        nodes.forEach(item => {
          if (!this.isSameNode(node, item)) {
            this.$set(item, 'selected', false)
            this.walkTreeSelectedStatus(item.nodes, item)
          }
          // 当前节点的子节点的禁用状态
          this.walkTreeDisabledStatus(item.nodes, item.deptId !== node.deptId)
        })
      }
      this.walkTree(node.nodes, node)
    },
    walkTreeDisabledStatus(nodeList, status) {
      if (!(nodeList && nodeList.length)) return

      nodeList.forEach(node => {
        this.$set(node, 'disabled', status)
        this.walkTreeDisabledStatus(node.nodes, status)
      })
    },
    // 处理节点的下一级
    handlerToGetSubNodes(node) {
      // 校区
      if (node.dormNodeType === NODE_TYPE.campus) {
        this.handlerCampusNext(node)
        return
      }

      this.methodUpdateNodeNav(node)
    },
    handlerCampusNext(node) {
      // 同一校区走缓存即可
      if (this.currentCampus.tpId === node.tpId) {
        this.methodUpdateNodeNav(node)
        return
      }
      this.currentCampus = node
      this.reqStatus = false
      this.getDormList()
        .then(res => {
          this.depts = res || []
          // 绑定 校区-宿舍
          node.nodes = this.depts
          this.methodUpdateNodeNav(node)
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
        .finally(() => {
          this.reqStatus = true
        })
    },
    // 将宿舍排到最后
    sortDormList(dormList) {
      if (!(dormList && dormList.length)) return []

      dormList.sort((a, b) => {
        return a.dormNodeType - b.dormNodeType
      })
      return dormList
    },
    getDorm(nodeList, dormList) {
      if (!(nodeList && nodeList.length)) return
      nodeList.forEach(node => {
        if (node.selected) {
          dormList.push(node)
        } else {
          this.getDorm(node.nodes, dormList)
        }
      })
    },
    getSelectedDormList() {
      let _dormList = []
      this.getDorm(this.depts, _dormList)
      return this.sortDormList(_dormList)
    },
    // 查看已选学生
    handlerViewDetail() {
      if (!this.computedResulCount) {
        return
      }
      this.selectedList = this.getSelectedDormList()
      this.isShowSelectDetail = true
    },
    // 回显删除
    handleDelete(index, node) {
      this.clearNodeList.push(node)
      this.selectedList.splice(index, 1)
    },
    clearDownwardTree(root = this.currentCampus) {
      ;(root.nodes || []).forEach(_node => {
        _node.selected = false
        _node.selectedCount = 0
        this.walkTreeSelectedStatus(_node.nodes, _node, true)
      })
    },
    ensureClearAction() {
      const _that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选宿舍？`,
        onConfirm() {
          _that.selectedList = []
          _that.clearDownwardTree()
          _that.$nextTick(() => {
            _that.isShowSelectDetail = false
          })
        }
      }).show()
    },
    confirmDetail() {
      this.clearNodeList.forEach(node => {
        node.selected = false
        node.selectedCount = 0
        // 往下遍历取消选择
        this.clearDownwardTree(node)
      })
      // 一定要整颗树都重新计算
      this.walkTreeSelectedCount()
      this.isShowSelectDetail = false
    },
    getSelectedDormCount(selectedList) {
      selectedList = selectedList || []
      return selectedList.reduce((total, currentValue) => {
        return total + (currentValue.selectedCount || 1)
      }, 0)
    },
    /**
     * 提交选择信息
     */
    handlerToSubmit() {
      let _selectedList = this.getSelectedDormList()

      this.close({
        dormBuildingId: this.computeDormBuildingId,
        selectedList: _selectedList,
        selectedCount: this.computedResulCount,
        campusId: this.currentCampus.tpId
      })
    },
    // 获取校区
    getCapmusList() {
      API.dingGetNewCapmusList()
        .then(res => {
          let _campusList = res || []
          _campusList = _campusList.map(item => {
            item.dormNodeType = NODE_TYPE.campus
            return item
          })
          this.campusList = _campusList

          // 如果需要回显
          if (
            this.selectedMap.campusId &&
            this.selectedMap.selectedList &&
            this.selectedMap.selectedList.length
          ) {
            // 找出当前校区
            this.currentCampus = this.campusList.find(item => {
              return item.tpId === this.selectedMap.campusId
            })
            // 展示回显
            // this.isShowSelectDetail = true
            return this.getDormList()
          }
        })
        .then(deptsList => {
          // 只有回显才会进入
          if (deptsList && deptsList.length) {
            this.depts = deptsList
            // 绑定 校区-宿舍
            this.currentCampus.nodes = this.depts
            this.methodUpdateNodeNav(this.currentCampus)

            // 同步状态
            this.walkTreeIsSelected(this.depts)
            this.depts.forEach(node => {
              this.walkTreeEchoSelected(node.nodes, node)
            })
            this.walkTreeSelectedCount()
            this.selectedList = this.getSelectedDormList()
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.reqStatus = true
        })
    },
    getDormList() {
      return new Promise((resolve, reject) => {
        API.getDormTree({
          campusId: this.currentCampus.tpId,
          operUserRoleTypes: this.role
        })
          .then(res => {
            if (res.message) return resolve([])
            const deptsList = res.nodes || []
            deptsList.forEach(item => {
              item.dormBuildingId = item.dormNodeId
              if ((item.nodes || []).length) {
                this.setBuildingId(item.nodes, item.dormNodeId)
              }
            })
            resolve(deptsList)
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {})
      })
    },
    setBuildingId(nodes, dormBuildingId) {
      nodes.forEach(node => {
        node.dormBuildingId = dormBuildingId
        const children = node.nodes || []
        if (children.length) {
          this.setBuildingId(children, dormBuildingId)
        }
      })
    },
    /**
     * 更新当前层级
     */
    methodUpdatecurrentType(type) {
      type = type || 0
      this.currentType = type
    },
    /**
     * 更新部门导航条
     */
    methodUpdateNodeNav(node, index) {
      if (index !== undefined && index > -1) {
        this.nodeNav = this.nodeNav.slice(0, index + 1)
      } else {
        let _flag = this.nodeNav.some(
          item => item.tpId && item.tpId === node.tpId
        )
        if (!_flag) {
          this.nodeNav.push(node)
        }
      }

      let _currentType = 0
      let _navLen = this.nodeNav.length
      if (_navLen) {
        _currentType = this.nodeNav[_navLen - 1].dormNodeType
      }
      this.methodUpdatecurrentType(_currentType)
    },
    //  退回拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.isShowSelectDetail) {
        // 没有确定返回就把清楚的还回去
        this.selectedList.push(...this.clearNodeList)
        this.clearConfirm && this.clearConfirm.hide()
        this.isShowSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(btnIndex => {
            if (btnIndex === 1) {
              this.closeOnly()
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.address-book {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  padding-bottom: 45px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .bg-no-data {
    background: #f6f6f6;
  }
  .disabled-choose {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .icon-no-data {
    width: 70px;
    height: 70px;
    background: url('~@/assets/images/staying-student.png');
    background-size: cover;
  }
  > div {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    background: #ffffff;
    &.select-wrap {
      padding-left: 0;
      padding-right: 0;
      background: #f6f6f6;
      .dorm-title {
        padding: 18px 16px 9px;
      }
    }
    // &:first-child {
    //   ~ div {
    //     margin-top: 8px;
    //   }
    // }
    &.node-nav {
      background: #f6f6f6;
      margin: 0;
      &.mt-10 {
        margin-top: 8px;
      }
    }
    &.select-all {
      height: 48px !important;
      min-height: 48px;
      line-height: 48px;
    }
    &.node-list {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      max-height: 80vh;

      > div {
        // height: 68px;

        &:last-child {
          border-bottom: none;
        }
        &.disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }
        .next {
          color: #006afe;
          padding-left: 8px;
          border-left: 1px solid rgba(#191f25, 0.12);
          &.disabled-choose {
            cursor: not-allowed;
            opacity: 0.5;
          }
        }
      }
    }
    &.result {
      height: 45px;
      color: #006afe;
      border-top: 1px solid rgba(#191f25, 0.12);
      position: absolute;
      left: 0;
      bottom: 0;
    }

    &.no-data {
      width: 100%;
      height: 100%;
      background: none;
      > span:first-child {
        margin-bottom: 0.4rem;
      }
    }
  }
  .footer {
    :deep(.c-button) {
      height: 46px;
      line-height: 46px;
      border-radius: 8px;
    }
  }
}
</style>
